module.exports = __webpack_public_path__ + "dingbeauty-landing/img/Icon_arrowR.03c947e9.svg";